import React from 'react';
import { useFormBuilder } from '../../../../contexts/FormBuilderContext';
import { useIntl } from 'react-intl';
import Input from '../../../common/Input/Input';
import styles from './LinearScaleEditor.module.css';

const LinearScaleEditor = ({ question }) => {
    const { updateQuestion } = useFormBuilder();
    const intl = useIntl();

    // Получаем текущие настройки или значения по умолчанию
    const config = question.config || { min: 1, max: 5, min_label: '', max_label: '' };

    const handleConfigChange = (field, value) => {
        // Для select преобразуем значение в число
        const numericValue = (field === 'min' || field === 'max') ? parseInt(value, 10) : value;
        const newConfig = { ...config, [field]: numericValue };
        updateQuestion(question.id || question.temp_id, { config: newConfig });
    };

    return (
        <div className={styles.editor}>
            <div className={styles.rangeSelector}>
                <label className={styles.label}>{intl.formatMessage({ id: "linearScaleEditor.range" })}</label>
                <div className={styles.selects}>
                    <span>{intl.formatMessage({ id: "linearScaleEditor.from" })}</span>
                    <select value={config.min} onChange={(e) => handleConfigChange('min', e.target.value)}>
                        <option value="0">0</option>
                        <option value="1">1</option>
                    </select>
                    <span>{intl.formatMessage({ id: "linearScaleEditor.to" })}</span>
                    <select value={config.max} onChange={(e) => handleConfigChange('max', e.target.value)}>
                        {[3, 4, 5, 6, 7, 8, 9, 10].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                </div>
            </div>
            <div className={styles.labels}>
                <Input
                    label={intl.formatMessage({ id: "linearScaleEditor.minLabel" })}
                    value={config.min_label || ''}
                    onChange={(e) => handleConfigChange('min_label', e.target.value)}
                />
                <Input
                    label={intl.formatMessage({ id: "linearScaleEditor.maxLabel" })}
                    value={config.max_label || ''}
                    onChange={(e) => handleConfigChange('max_label', e.target.value)}
                />
            </div>
        </div>
    );
};

export default LinearScaleEditor;
